import { getConfiguration } from "./configuration";
import { getLocaleTimestamp } from "./getLocaleTimestamp";

// input is a timestamp YYYYMMDD hh:mm
export function formatDate(times, skipUtcConversion = false) {
	const conf = getConfiguration();
	skipUtcConversion = skipUtcConversion == null ? false : skipUtcConversion;
	if (conf.dbutc && !skipUtcConversion) {
		// converting the input timestamp into a similar timestamp with the offset of this browser
		times = getLocaleTimestamp(times); 
	}
	const timestamp = times;
	const date = {};
	const year = timestamp.substring(0, 4);
	const yearTrunc = year.substring(2, 4);
	const month = timestamp.substring(4, 6);
	const day = timestamp.substring(6, 8);
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    if (timestamp.length > 8) {
        hours = timestamp.substring(9, 11);
        minutes = timestamp.substring(12, 14);
        seconds = '00';
    }

	if (timestamp.length >= 17) {
		seconds = timestamp.substring(15, 17);
    }
	
	let mms = minutes;
	if (mms.length === 1) {
		mms += '0';
	}
	
	let dds = day;
	if (dds.length === 1) {
		dds = `0${dds}`;
	}
	
	let mons = month;
	if (mons.length === 1) {
		mons = `0${mons}`;
	}
	
	dds = day;
	date.formatted = `${dds}/${mons}/${year} ${hours}:${mms}`;
	date.formatted_no_hour = `${dds}/${mons}/${year}`;
	date.formatted_day_month = `${dds}/${mons}`;
	date.formatted_trunc_year = `${dds}/${mons}/${yearTrunc} ${hours}:${mms}`;
	date.year = parseInt(year, 10);
	date.month = parseInt(month, 10);
	date.day = parseInt(day, 10);
	date.hours = parseInt(hours, 10);
	date.minutes = parseInt(minutes, 10);
	date.seconds = parseInt(seconds, 10);
	date.time = `${hours}:${mms}`;
	
	return date;	
}
